module.exports = __webpack_public_path__ + "media/images/menu/m1-1f9f9e3df9c7ccc6815eb5a0eeb414ce.JPG";